"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ButtonKind", {
  enumerable: true,
  get: function get() {
    return _Anchor.AnchorElementKind;
  }
});
exports.IconPosition = exports.ButtonSizes = exports.ButtonColor = void 0;

var _Anchor = require("../Anchor");

var ButtonColor;
exports.ButtonColor = ButtonColor;

(function (ButtonColor) {
  ButtonColor["PRIMARY"] = "primary";
  ButtonColor["SECONDARY"] = "secondary";
  ButtonColor["TERTIARY"] = "tertiary";
})(ButtonColor || (exports.ButtonColor = ButtonColor = {}));

var ButtonSizes;
exports.ButtonSizes = ButtonSizes;

(function (ButtonSizes) {
  ButtonSizes["SMALL"] = "small";
  ButtonSizes["MEDIUM"] = "medium";
})(ButtonSizes || (exports.ButtonSizes = ButtonSizes = {}));

var IconPosition;
exports.IconPosition = IconPosition;

(function (IconPosition) {
  IconPosition["LEFT"] = "left";
  IconPosition["RIGHT"] = "right";
})(IconPosition || (exports.IconPosition = IconPosition = {}));